// ── Domain types ─────────────────────────────────────────────────────────────
export { isPrivateRelayEmail } from './shared/private-relay';
export type { User } from './types/user';
export type {
  PendingAction,
  AuthObservabilityService,
} from './types/ports';
export type {
  SignUpProps,
  ValidateUserRequest,
  ValidateUserTheme,
  ValidateUserResponse,
  AuthErrorResponse,
  SignInResult,
  SignUpResult,
  ConfirmSignUpResult,
  AuthProviderFeatures,
  SocialProvider,
} from './types/results';
export { AuthFlow } from './types/results';
export { PASSWORD_MIN_LENGTH } from './shared/password-policy';

// ── Sign-in flow (public types only — internals stay private) ────────────────
export type { SignInState } from './flows/sign-in';

// ── Sign-up flow (public types only — internals stay private) ────────────────
export type { SignUpState } from './flows/sign-up';

// ── Event bus ────────────────────────────────────────────────────────────────
export type { AuthEvent } from './types/events';

// ── React hooks & provider ───────────────────────────────────────────────────
export { AuthProvider, useAuth } from './react/auth-provider';
export type { AuthState } from './react/auth-provider';
export { useUser } from './react/use-user';
export type { UseAuthReturn } from './react/use-auth';
export { useSignIn } from './react/use-sign-in';
export type { UseSignInReturn } from './react/use-sign-in';
export { useSignUp } from './react/use-sign-up';
export type { UseSignUpReturn } from './react/use-sign-up';
export { useSessionGuard } from './react/use-session-guard';
export { useAuthEvent } from './react/use-auth-events';

// ── Constants ────────────────────────────────────────────────────────────────
export { AuthErrorCode } from './constants';

// ── Infrastructure ───────────────────────────────────────────────────────────
export { initAuth } from './infrastructure/factory';
export { deserializeUser } from './infrastructure/session-persistence';

// ── Observability ────────────────────────────────────────────────────────────
export { AuthObservabilityServiceImpl, detectAuthMethod } from './observability/service';
export {
  AUTH_REGISTER_FAILURE,
  AUTH_SIGNIN_FAILURE,
  AUTH_ERROR_INVALID_CREDENTIALS,
  AUTH_ERROR_VALIDATION,
  AUTH_ERROR_API,
  AUTH_ERROR_UNKNOWN,
} from './observability/events';
